import { StockPeer } from '@/components/Stocks/Widgets/types'
import TwoColGrid from '@/components/Stocks/Widgets/InStockV2/TwoColGrid'

type Tprops = {
  stats?: StockPeer
  company_name?: string
  fundamental_data?: {
    book_value?: number
    qtr_growth_yoy?: number
    ebitda?: string
    revenue_ttm?: string
    profit_margin?: number
  }
  industry_pe_ratio?: number
}

const CatalogueKeyStats = ({
  stats,
  company_name,
  fundamental_data,
  industry_pe_ratio,
}: Tprops) => {
  return (
    <TwoColGrid
      heading={`${company_name} Stock Fundamentals & Key Indicators`}
      subheading={`Check ${company_name} market cap, PE, PB, PEG ratios, dividend yield, and other key fundamental indicators.`}
      keyValueData={[
        {
          key: 'Market Cap',
          value: `${stats?.market_cap_value ?? ''}`,
        },
        { key: 'EPS (TTM)', value: stats?.eps ?? '' },
        { key: 'Dividend Yield', value: stats?.dividend_yield_perc ?? '' },
        {
          key: 'Quarterly Earnings Growth YOY',
          value: fundamental_data?.qtr_growth_yoy ?? '',
        },
        { key: 'PE Ratio (TTM)', value: stats?.pe_ratio ?? '' },
        { key: 'Industry PE ratio', value: industry_pe_ratio ?? '' },
        { key: 'P/B Ratio', value: stats?.pb_ratio ?? '' },
        { key: 'PEG Ratio', value: stats?.peg_ratio ?? '' },
        { key: 'Sector', value: stats?.sector ?? '' },
        { key: 'EBITDA', value: fundamental_data?.ebitda ?? '' },
        {
          key: 'Revenue (TTM)',
          value: fundamental_data?.revenue_ttm ?? '',
        },
        {
          key: 'Profit Margin ',
          value: fundamental_data?.profit_margin ?? '',
        },
        {
          key: 'Return On Equity TTM',
          value: stats?.roe_perc ?? '',
        },
      ]}
    />
  )
}

export default CatalogueKeyStats
